<template>
    <v-container fluid>
        <Overlay />
    </v-container>
</template>

<script>
import Overlay from '../../../../components/Overlay';
import { mapActions } from 'vuex';

export default {
    components: { Overlay },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'pageEditor/getData',
            saveData: 'pageEditor/saveData',
        })
    }
};
</script>
